import { render, staticRenderFns } from "./PackageList.vue?vue&type=template&id=e786e2d6&scoped=true&"
import script from "./PackageList.vue?vue&type=script&lang=ts&"
export * from "./PackageList.vue?vue&type=script&lang=ts&"
import style0 from "./PackageList.vue?vue&type=style&index=0&id=e786e2d6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e786e2d6",
  null
  
)

export default component.exports